<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const { locale } = useI18n()
const { $notyf } = useNuxtApp()
const url = useRequestURL()
const config = useNuxtApp().$config

// sections
const pageSections = ref<IHomePageSectionModel[]>()
const pageMetaObject = ref<{ [key: string]: string } | undefined>()
const pageHeaderSection = ref<ICMSLocationContent>()
const pageTextSection = ref<ICMSLocationContent>()
const pageFaqSection = ref<ICMSLocationContent>()
const metaContent = ref<ICMSLocationContentTranslations>()
provide('pageHeaderSection', pageHeaderSection)
provide('pageTextSection', pageTextSection)
provide('pageFaqSection', pageFaqSection)
provide('pageSections', pageSections)
const subpagesContentStore = useSubpagesContentStore()
const getPageSections = async () => {
	try {
		const response = await subpagesContentStore.fetchPageSections('short-term')
		pageSections.value = response
		pageHeaderSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.PAGE_HEADER_IMAGE)
		pageMetaObject.value = pageSections.value?.find((section) => section.name === EPageSectionType.META)
		pageTextSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.CONTENT_SECTION)
		pageFaqSection.value = pageSections.value?.find((section) => section.name === EPageSectionType.FAQ)
		metaContent.value = pageMetaObject.value?.translations.find((translation) => translation.language === locale.value)?.content[0]
	} catch (error) {
		$notyf.error('Error while fetching page sections')
		logger.log(error)
	}
}

await getPageSections()

const robotsCalculated = useRobotsMeta(() => metaContent.value?.robots)

usePageViewed(EGTMPageType.SHORT_TERM_RENTAL)
</script>

<template>
	<div>
		<!-- definePageMeta -->
		<Head>
			<Title>{{ metaContent?.title ? ensureBrandSuffix(metaContent.title) : `${$t('pages.short_term.rent_for_days')} | CarFree` }}</Title>
			<Meta name="description" :content="metaContent?.description ?? ''" />
			<Meta v-if="config.public.isIndex" name="robots" :content="robotsCalculated" />
			<Meta v-else name="robots" content="noindex, nofollow" />
			<Link
				rel="canonical"
				:href="metaContent?.canonical && metaContent?.canonical?.trim() !== '' ? metaContent?.canonical : `${url.origin}${url.pathname}`" />
		</Head>

		<GlobalHeader />
		<CarRentalPageHero :title="$t('pages.short_term.rent_for_days')" />
		<HomePageChooseCar noBooker :min-months="1" :max-months="12" init />
		<LazyLongTermPageBenefits />
		<LazyLongTermPageSpecialOffer
			image="medium-term-special-offer.png"
			:type="ESpecialDailyOfferType.SHORT_TERM"
			:min-val="1"
			:max-val="30"
			:label="EFormLabel.DAYS"
			:timeframe="EContactFormRentalTimeframe.SHORT_TERM" />
		<LazyLongTermPageContact :min-val="1" :max-val="30" :label="EFormLabel.DAYS" :timeframe="EContactFormRentalTimeframe.SHORT_TERM" />
		<LazyCarRentalTextSection />
		<LazyCarRentalFaq :pageTitle="$t('components.nav.mega_menu.short_term_rentals')" />
		<LazyGlobalApplicationBanner :without-margin="true" />
	</div>
</template>
